class DropDownHelper {

	public isDropDownUp(): boolean {
		const dropdown = document.querySelector('.dropdown.is-active');
		const menu = dropdown ? dropdown.querySelector('.dropdown-menu') : null;
		if (menu) {
			const position = menu.getBoundingClientRect();
			const padding = 10;
			if (position.bottom > window.innerHeight - padding) {
				return true;
			}
		}
		return false;
	}
}

export const dropDownHelper = new DropDownHelper();
